/**
 * Conjoin a list of phrases to a sentence:
 * ```toSentence(["Motorcycle", "Truck", "Car"]) => "Motorcycle, Truck, and Car"```
 * TODO: Convert this to use Intl.ListFormat when Typescript + NodeJS has better bindings
 * @param phrases Array of words to conjoin
 */
export default function toSentence(phrases: string[]): string {
  if (phrases.length <= 1) {
    return phrases[0] ?? ''
  } else if (phrases.length === 2) {
    return [phrases[0], phrases[1]].join(' and ')
  } else {
    return [
      phrases.slice(0, phrases.length - 1).join(', '),
      phrases[phrases.length - 1],
    ].join(', and ')
  }
}
